function NexproErrorNotification(errorObject, data = {}) {
  const {
    enterprise_code = 'unknown',
    file_name = 'unknown',
    attributes = {}
  } = data;

  const isErrorInstance = errorObject instanceof Error;
  const message = `NexProJSError: ${errorObject?.message || 'unknown'}`;
  const error = isErrorInstance ? new Error(message) : new Error('NexProJSError: Invalid or missing error object');

  const finalAttributes = {
    ...attributes, // 任意の追加属性
    enterprise_code,
    file_name,
    message,
    errorSource: 'nexproErrorNotification'
  };
  newrelic.noticeError(error, finalAttributes);
}

export default function NexproErrorHandling(errorObject, data) {
  NexproErrorNotification(errorObject, data);
}
